export default __webpack_public_path__ + "static/media/Workload_Main.410f1fd4.png";